<script lang="ts" setup>
import { PropType } from 'vue';

defineProps({
  value: {
    type: String as PropType<string>,
    required: false,
  },
  placeholder: {
    type: String as PropType<string>,
    required: false,
    default: '',
  },
  style: {
    type: String as PropType<string>,
    required: false,
    default: '',
  },
  custom: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  index: {
    type: Number as PropType<number>,
    required: false,
  },
  validate: {
    type: Boolean as PropType<boolean>,
    required: false,
  },
  number: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  email: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  noLogo: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
});
defineEmits({
  change: null,
});

const uuid = Math.random().toString();
</script>

<template>
  <div>
    <label v-if="!noLogo" :for="uuid" class="text-dark">
      {{ placeholder }}
    </label>
    <input
      :class="[
        `px-2 shadow-md h-[43px] lg:h-[52px] rounded-[5px] text-dark ${
          custom ? style : 'w-full lg:w-[693px]'
        }`,
        validate ? 'outline outline-2 outline-red-500' : '',
      ]"
      :type="number ? 'number' : email ? 'email' : 'text'"
      :value="value"
      :id="uuid"
      :placeholder="noLogo ? placeholder : ''"
      @input="(e) => $emit('change', (e.target as HTMLInputElement)?.value, index)"
      :disabled="disabled"
    />
  </div>
</template>

<style scoped>
input:disabled {
  background: white;
}
</style>
